import React, { useState } from 'react';
import { doc, updateDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { Input, Button } from '../components/UI';

export default function EditChildScreen({ user, child, navigate }) {
    const [name, setName] = useState(child.name || '');
    const [dob, setDob] = useState(child.dob.toDate().toISOString().split('T')[0] || '');
    const [gender, setGender] = useState(child.gender || '');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            // FIX: Use ownerUid if it exists, otherwise fallback to user.uid
            const ownerUid = child.ownerUid || user.uid;
            const childDocRef = doc(db, `users/${ownerUid}/children/${child.id}`);
            
            await updateDoc(childDocRef, {
                name,
                dob: Timestamp.fromDate(new Date(dob)),
                gender,
            });
            alert('Data anak berhasil diperbarui!');
            navigate('viewChild', child); 
        } catch (err) {
            console.error(err);
            setError('Gagal memperbarui data anak.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F8FAFC] font-sans selection:bg-sky-200 pb-28 pt-8 px-5 relative">
            {/* Animated Background Mesh */}
            <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
                <div className="absolute top-[10%] left-[-20%] w-[60vw] h-[60vw] bg-sky-200 rounded-full mix-blend-multiply filter blur-[100px] opacity-40 animate-blob"></div>
                <div className="absolute top-[40%] right-[-20%] w-[50vw] h-[50vw] bg-indigo-200 rounded-full mix-blend-multiply filter blur-[100px] opacity-40 animate-blob animation-delay-2000"></div>
                <div className="absolute bottom-[-10%] left-[10%] w-[70vw] h-[70vw] bg-blue-200 rounded-full mix-blend-multiply filter blur-[100px] opacity-30 animate-blob animation-delay-4000"></div>
                <div className="absolute inset-0 bg-white/40 backdrop-blur-[50px]"></div>
            </div>

            <div className="relative z-10 max-w-md mx-auto">
                <div className="text-center mb-8">
                    <div className="w-16 h-16 bg-white/60 backdrop-blur-md rounded-[1.25rem] flex items-center justify-center text-3xl mx-auto mb-4 shadow-sm border border-white">
                        ✏️
                    </div>
                    <h2 className="text-2xl font-extrabold text-gray-800 tracking-tight">Ubah Data Anak</h2>
                    <p className="text-sm text-gray-500 mt-2">Perbarui informasi dasar profil anak.</p>
                </div>

                <div className="bg-white/60 backdrop-blur-2xl rounded-[1.5rem] p-6 border border-white shadow-[0_8px_30px_rgba(0,0,0,0.04)] relative overflow-hidden">
                    <form onSubmit={handleSubmit} className="space-y-5 relative z-10">
                        {error && (
                            <div className="bg-rose-50 border border-rose-200 text-rose-600 p-3 rounded-xl text-sm font-medium">
                                {error}
                            </div>
                        )}
                        
                        <div>
                            <label className="block text-gray-700 text-xs font-bold mb-2 uppercase tracking-wide">Nama Lengkap Anak</label>
                            <input 
                                type="text" 
                                value={name} 
                                onChange={e => setName(e.target.value)} 
                                required 
                                className="w-full bg-white/80 border border-gray-200 text-gray-800 text-sm font-bold rounded-xl focus:ring-sky-500 focus:border-sky-500 block p-3.5 shadow-sm outline-none transition-all"
                            />
                        </div>

                        <div>
                            <label className="block text-gray-700 text-xs font-bold mb-2 uppercase tracking-wide">Tanggal Lahir</label>
                            <input 
                                type="date" 
                                value={dob} 
                                onChange={e => setDob(e.target.value)} 
                                required 
                                className="w-full bg-white/80 border border-gray-200 text-gray-800 text-sm font-bold rounded-xl focus:ring-sky-500 focus:border-sky-500 block p-3.5 shadow-sm outline-none transition-all"
                            />
                        </div>

                        <div>
                            <label className="block text-gray-700 text-xs font-bold mb-2 uppercase tracking-wide">Jenis Kelamin</label>
                            <select 
                                value={gender} 
                                onChange={e => setGender(e.target.value)} 
                                required
                                className="w-full bg-white/80 border border-gray-200 text-gray-800 text-sm font-bold rounded-xl focus:ring-sky-500 focus:border-sky-500 block p-3.5 shadow-sm outline-none transition-all"
                            >
                                <option value="Laki-laki">Laki-laki</option>
                                <option value="Perempuan">Perempuan</option>
                            </select>
                        </div>

                        <Button 
                            type="submit" 
                            disabled={loading}
                            className="w-full bg-gray-900 text-white hover:bg-gray-800 shadow-xl py-4 rounded-xl mt-4 transition-all"
                        >
                            {loading ? 'Menyimpan...' : 'Simpan Perubahan'}
                        </Button>
                    </form>
                </div>
            </div>
            <style>{`
                @keyframes blob {
                    0% { transform: translate(0px, 0px) scale(1); }
                    33% { transform: translate(30px, -50px) scale(1.1); }
                    66% { transform: translate(-20px, 20px) scale(0.9); }
                    100% { transform: translate(0px, 0px) scale(1); }
                }
                .animate-blob { animation: blob 15s infinite alternate ease-in-out; }
                .animation-delay-2000 { animation-delay: 2s; }
                .animation-delay-4000 { animation-delay: 4s; }
            `}</style>
        </div>
    );
}
